import React, { useState, useEffect } from "react";
import { Button, Typography } from "@material-ui/core";
import BrokenImageIcon from "@material-ui/icons/BrokenImage";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: "auto", // Redimensionar automaticamente a altura para manter a proporção
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	},
	unavailableMedia: {
		width: 250,
		minHeight: 120,
		padding: theme.spacing(1.5),
		borderRadius: 8,
		border: "1px solid rgba(0, 0, 0, 0.12)",
		backgroundColor: "rgba(255, 255, 255, 0.72)",
		color: theme.palette.text.secondary,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		gap: theme.spacing(1),
		textAlign: "center",
	},
	unavailableIcon: {
		color: theme.palette.text.disabled,
		fontSize: 32,
	},
	openButton: {
		textTransform: "none",
	}
}));

const ModalImageCors = ({ imageUrl }) => {
	const classes = useStyles();
	const [fetching, setFetching] = useState(true);
	const [blobUrl, setBlobUrl] = useState("");
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		if (!imageUrl) return;
		let active = true;
		let currentBlobUrl = "";

		const fetchImage = async () => {
			setFetching(true);
			setHasError(false);
			setBlobUrl("");

			try {
				const { data, headers } = await api.get(imageUrl, {
					responseType: "blob",
				});
				const url = window.URL.createObjectURL(
					new Blob([data], { type: headers["content-type"] })
				);
				currentBlobUrl = url;

				if (active) {
					setBlobUrl(url);
					setFetching(false);
				}
			} catch (err) {
				if (active) {
					setHasError(true);
					setFetching(false);
				}
			}
		};

		fetchImage();

		return () => {
			active = false;
			if (currentBlobUrl) {
				window.URL.revokeObjectURL(currentBlobUrl);
			}
		};
	}, [imageUrl]);

	if (hasError) {
		return (
			<div className={classes.unavailableMedia}>
				<BrokenImageIcon className={classes.unavailableIcon} />
				<Typography variant="body2">
					Midia indisponivel
				</Typography>
				<Button
					className={classes.openButton}
					component="a"
					href={imageUrl}
					target="_blank"
					rel="noopener noreferrer"
					size="small"
					variant="outlined"
					startIcon={<OpenInNewIcon />}
				>
					Abrir arquivo
				</Button>
			</div>
		);
	}

	return (
		<ModalImage
			className={classes.messageMedia}
			smallSrcSet={fetching ? imageUrl : blobUrl}
			medium={fetching ? imageUrl : blobUrl}
			large={fetching ? imageUrl : blobUrl}
			alt="image"
			showRotate={true}
		/>
	);
};

export default ModalImageCors;
